import React from 'react';
import defaultLocale from 'components/locale/defaultLocale';
import useStyles from './infoDisplay.styles';

interface Props {
  children?: JSX.Element;
  containerClass?: string;
  dataQa?: string;
  defaultValue?: string;
  label: string;
  labelClass?: string;
  value?: string | JSX.Element | null;
  valueClass?: string;
}

const InfoDisplay = ({
  children,
  containerClass,
  dataQa,
  defaultValue = defaultLocale['common.field.empty'],
  label,
  labelClass,
  value,
  valueClass
}: Props) => {
  const { container: defaultContainerClass, label: defaultLabelClass } = useStyles();

  return (
    <div className={containerClass || defaultContainerClass} data-qa={`info-container-${dataQa}`}>
      <p className={labelClass || defaultLabelClass} data-qa={`label-${dataQa}`}>
        {label}
      </p>
      <p className={valueClass} data-qa={dataQa}>
        {value || defaultValue}
      </p>
      {children}
    </div>
  );
};

export default InfoDisplay;
